import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["province"]

  static targets = ["select"]

  change() {
    this.provinceOutlet.refresh(this.selectedCountry)
    this.dispatch("change", { detail: { country: this.selectedCountry } })
  }

  // outlet API: read by users/fields_controller via the country outlet
  get isNamibia() {
    return this.selectedCountry === "NA"
  }

  // outlet API: read by users/fields_controller via the country outlet
  get selectedCountry() {
    return this.selectTarget.value
  }
}
